<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {computed, ref} from "vue";
import CustomCheckbox from "../../global-themed/CustomCheckbox.vue";
import {useStore} from "vuex";

const store = useStore()
const confirmed = ref(false)
const websites = computed(() => store.getters['agencyCancellation/websitesWithPublishedChanges'])
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container tw-rounded-xl tw-bg-white tw-p-8 tw-text-black">
    <div class="tw-flex tw-flex-col">
      <div class="tw-mb-5 tw-text-4xl tw-font-bold tw-leading-9 tw-text-slate-100">
        Some websites are still using the Onsite Optimizer
      </div>
      <div class="tw-mb-5 tw-flex tw-flex-col tw-gap-5 tw-text-base tw-leading-7 tw-text-slate-200">
        <div>
          We've noticed that the Onsite Optimizer script remains installed on websites linked to your account. If you proceed with cancelling your Hike Agency account, <span class="tw-font-bold">all changes made via the Onsite Optimizer</span> will be removed from these websites.
        </div>
        <div class="tw-flex tw-flex-col">
          <span class="text-bold">Websites with the Onsite Optimizer installed:</span>
          <span>Below, you'll find a list of websites with the Onsite Optimizer script still present. We strongly recommend downloading a CSV file of all SEO adjustments you've made to each site. This record is crucial for you or your client to manually reimplement these changes, if necessary.</span>
        </div>

        <div
          v-for="website in websites"
          :key="website.id"
          class="tw-ml-4 tw-flex tw-gap-3"
        >
          <span>{{ website.url }}</span>
          <span>({{ website.count }} Published {{ website.count === 1 ? 'change' : 'changes' }})</span>
          <a
            v-if="website.count > 0"
            class="tw-underline tw-cursor-pointer"
            @click.prevent="store.dispatch('onsiteEditor/fetchChangesCsv', website.id)"
          >Download CSV</a>
        </div>
      </div>

      <CustomCheckbox
        id="confirmation"
        v-model="confirmed"
        label="By ticking this box you confirm you have removed the optimizer from the websites above"
        class="tw-mt-4"
      />

      <div class="tw-mt-12 tw-flex tw-justify-between">
        <DefaultButton
          class="!tw-w-[189px]"
          @click="store.dispatch('agencyCancellation/previousStep')"
        >
          Go Back
        </DefaultButton>
        <div class="tw-flex tw-gap-3">
          <DefaultButton
            class="!tw-bg-denali"
            variant="primary"
            :disabled="!confirmed"
            @click="() => store.dispatch('agencyCancellation/nextStep')"
          >
            Cancel Account
          </DefaultButton>
        </div>
      </div>
    </div>
  </div>
</template>
